import { I18n } from 'i18n-js'     // <- export nommé

//import * as I18n from 'i18n-js'

import fr from "../i18n/fr.json"
import en from "../i18n/en.json"

const i18n = new I18n({
  fr: fr.fr,
  en: en.en,
})

// Synchronise avec la locale côté Rails (voir helper ci-dessous)
i18n.locale = document.documentElement.lang || "fr"
i18n.defaultLocale = 'fr'
i18n.fallbacks     = true

export default i18n